import { Component, inject, input, OnInit } from '@angular/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { TranslateModule } from '@ngx-translate/core';
import {
  FieldConfig,
  FieldType,
  FormConfig,
  ConnectionMethods,
  GetConnectionResponse,
  GetIntegrationResponse,
} from '@vendasta/platform-integrations';
import { CommonModule } from '@angular/common';

import { MatFormFieldModule } from '@angular/material/form-field';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyInputModule } from '@vendasta/galaxy/input/src/input.module';
import { PasswordFieldComponent } from './fields/password/password.component';
import { LabelFieldComponent } from './fields/label/label.component';
import { URLFieldComponent } from './fields/url/url.component';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'platform-integration-instructions',
  imports: [
    GalaxyAlertModule,
    TranslateModule,
    CommonModule,
    MatFormFieldModule,
    GalaxyFormFieldModule,
    MatButtonModule,
    GalaxyInputModule,
    PasswordFieldComponent,
    LabelFieldComponent,
    URLFieldComponent,
  ],
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent implements OnInit {
  private readonly cookieService = inject(CookieService);
  instructions = input.required<FormConfig>();
  connection = input.required<GetConnectionResponse>();
  integration = input.required<GetIntegrationResponse>();
  protected readonly connectionMethods = ConnectionMethods;
  protected readonly fieldType = FieldType;
  dismissed = false;
  cookieKey = '';
  ngOnInit(): void {
    this.cookieKey = `dismissedInstruction_${this.integration()?.integrationType}_${this.connection()?.status}`;
    this.dismissed = Boolean(this.cookieService.get(this.cookieKey));
  }

  dismissInstruction(): void {
    this.cookieService.set(this.cookieKey, 'true', 0, '/', '');
    this.dismissed = true;
  }
  getFieldValue(field: FieldConfig) {
    switch (field.fieldType) {
      case FieldType.FIELD_TYPE_PASSWORD:
        return (
          this.connection().customFields.find((customField) => {
            return customField.label === field.id;
          })?.value || field.placeHolder
        );
      default:
        return field.placeHolder;
    }
  }
}
